"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2516],{

/***/ 92516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ getProfile; },
/* harmony export */   "Dx": function() { return /* binding */ adminUpdatePhoneNumber; },
/* harmony export */   "Gd": function() { return /* binding */ confirmAndUpdatePhoneNumberViaCode; },
/* harmony export */   "JK": function() { return /* binding */ updateStubUser; },
/* harmony export */   "M_": function() { return /* binding */ getUserDetails; },
/* harmony export */   "Nq": function() { return /* binding */ updateUser; },
/* harmony export */   "Tj": function() { return /* binding */ adminUpdateEmail; },
/* harmony export */   "Wv": function() { return /* binding */ adminUpdateBirthDate; },
/* harmony export */   "YU": function() { return /* binding */ confirmAndUpdateEmailViaCode; },
/* harmony export */   "_K": function() { return /* binding */ sendPhoneNumberVerificationCode; },
/* harmony export */   "_V": function() { return /* binding */ readUsers; },
/* harmony export */   "an": function() { return /* binding */ setIsBlacklisted; },
/* harmony export */   "dv": function() { return /* binding */ sendEmailVerificationCode; },
/* harmony export */   "ek": function() { return /* binding */ adminUpdateLastName; },
/* harmony export */   "oV": function() { return /* binding */ confirmAndUpdateUserPhoneNumber; },
/* harmony export */   "sF": function() { return /* binding */ sendPhoneNumberVerificationCodeWithAuth; },
/* harmony export */   "xq": function() { return /* binding */ adminUpdateFirstName; }
/* harmony export */ });
/* unused harmony exports CURRENT_USER, changeMailingList, getDependants, addDependant, updateDependant, deleteDependant */
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16835);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53901);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22877);




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var CURRENT_USER = "CurrentUser";

var translateResponse = function translateResponse(data) {
  var _data$filtersInformat;

  if (data.error) {
    throw new Error(data.error);
  }

  return {
    data: data === null || data === void 0 ? void 0 : data.users,
    pageInformation: data === null || data === void 0 ? void 0 : data.pageInformation,
    filters: data === null || data === void 0 ? void 0 : (_data$filtersInformat = data.filtersInformation) === null || _data$filtersInformat === void 0 ? void 0 : _data$filtersInformat.filters
  };
};

var createFiltersQueries = function createFiltersQueries(userFilters) {
  if (!userFilters) {
    return "";
  }

  var queryParams = [];

  for (var _i = 0, _Object$entries = Object.entries(userFilters); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value !== null) {
      if (Array.isArray(value)) {
        var _iterator = _createForOfIteratorHelper(value),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var val = _step.value;
            queryParams.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(val.toString())));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        queryParams.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value.toString())));
      }
    }
  }

  return queryParams.join("&");
};

var readUsers = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var pageSize,
        pageIndex,
        filters,
        filterQueries,
        fetchUrl,
        res,
        remoteData,
        data,
        message,
        _args = arguments;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageSize = _args.length > 0 && _args[0] !== undefined ? _args[0] : 5;
            pageIndex = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
            filters = _args.length > 2 ? _args[2] : undefined;
            _context.prev = 3;
            filterQueries = createFiltersQueries(filters);
            fetchUrl = "/api/backend/v1/users?".concat(filterQueries ? filterQueries + "&" : "", "pageSize=").concat(pageSize, "&pageIndex=").concat(pageIndex);
            _context.next = 8;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 8:
            res = _context.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 11;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 11:
            _context.next = 13;
            return res.json();

          case 13:
            remoteData = _context.sent;
            data = translateResponse(remoteData);
            return _context.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .UserListResponse */ .xA(data));

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](3);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = "Unable to load shows";
            }

            return _context.abrupt("return", new _models_types__WEBPACK_IMPORTED_MODULE_1__/* .UserListResponse */ .xA({
              error: message
            }));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 18]]);
  }));

  return function readUsers() {
    return _ref.apply(this, arguments);
  };
}();
var updateUser = /*#__PURE__*/function () {
  var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(user) {
    var res;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify(user)
            });

          case 3:
            res = _context2.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", false);

          case 6:
            return _context2.abrupt("return", true);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function updateUser(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var sendPhoneNumberVerificationCode = /*#__PURE__*/function () {
  var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(user, tokenOrbookingInterestId) {
    var fetchUrl, res, response;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            fetchUrl = "/api/backend/v1/users/send-phone-number-verification-code/".concat(tokenOrbookingInterestId);

            if (!(typeof tokenOrbookingInterestId === 'string')) {
              _context3.next = 8;
              break;
            }

            _context3.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)(fetchUrl, {
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify(user)
            });

          case 5:
            res = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.next = 10;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify(user)
            });

          case 10:
            res = _context3.sent;

          case 11:
            if (!(res.status >= 400 && res.status < 600)) {
              _context3.next = 16;
              break;
            }

            _context3.next = 14;
            return res.json();

          case 14:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 16:
            return _context3.abrupt("return", res);

          case 19:
            _context3.prev = 19;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _context3.t0);

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 19]]);
  }));

  return function sendPhoneNumberVerificationCode(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
var confirmAndUpdateUserPhoneNumber = /*#__PURE__*/function () {
  var _ref4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(phoneNumber, phoneNumberVerificationCode, tokenOrbookingInterestId) {
    var fetchUrl, res, response;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            fetchUrl = "/api/backend/v1/users/confirm-and-update-phone-number/".concat(tokenOrbookingInterestId);

            if (!(typeof tokenOrbookingInterestId === 'string')) {
              _context4.next = 8;
              break;
            }

            _context4.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)(fetchUrl, {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                phoneNumber: phoneNumber,
                phoneNumberVerificationCode: phoneNumberVerificationCode
              })
            });

          case 5:
            res = _context4.sent;
            _context4.next = 11;
            break;

          case 8:
            _context4.next = 10;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)(fetchUrl, {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                phoneNumber: phoneNumber,
                phoneNumberVerificationCode: phoneNumberVerificationCode
              })
            });

          case 10:
            res = _context4.sent;

          case 11:
            if (!(res.status >= 400 && res.status < 600)) {
              _context4.next = 16;
              break;
            }

            _context4.next = 14;
            return res.json();

          case 14:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 16:
            return _context4.abrupt("return", res);

          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", {
              error: _context4.t0
            });

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 19]]);
  }));

  return function confirmAndUpdateUserPhoneNumber(_x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
var updateStubUser = /*#__PURE__*/function () {
  var _ref5 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(user) {
    var res;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/stub-user", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify(user)
            });

          case 3:
            res = _context5.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context5.next = 6;
              break;
            }

            return _context5.abrupt("return", false);

          case 6:
            return _context5.abrupt("return", true);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", _context5.t0);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function updateStubUser(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
var getUserDetails = /*#__PURE__*/function () {
  var _ref6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(id) {
    var res, userDetails;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/".concat(id));

          case 3:
            res = _context6.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context6.next = 6;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 6:
            _context6.next = 8;
            return res.json();

          case 8:
            userDetails = _context6.sent;
            return _context6.abrupt("return", userDetails.user);

          case 12:
            _context6.prev = 12;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", _context6.t0);

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 12]]);
  }));

  return function getUserDetails(_x8) {
    return _ref6.apply(this, arguments);
  };
}();
var getProfile = /*#__PURE__*/function () {
  var _ref7 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
    var res, profile;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/profile");

          case 3:
            res = _context7.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context7.next = 6;
              break;
            }

            throw {
              loginStatus: "logged out"
            };

          case 6:
            _context7.next = 8;
            return res.json();

          case 8:
            profile = _context7.sent;
            return _context7.abrupt("return", profile);

          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](0);
            throw _context7.t0;

          case 15:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 12]]);
  }));

  return function getProfile() {
    return _ref7.apply(this, arguments);
  };
}();
var changeMailingList = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(value) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return fetchWithAuth("/api/backend/v1/users/mailing-list?emailPreference=".concat(value), {
              method: "POST"
            });

          case 3:
            res = _context8.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context8.next = 6;
              break;
            }

            return _context8.abrupt("return", false);

          case 6:
            return _context8.abrupt("return", true);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            throw _context8.t0;

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 9]]);
  }));

  return function changeMailingList(_x9) {
    return _ref8.apply(this, arguments);
  };
}()));
var setIsBlacklisted = /*#__PURE__*/function () {
  var _ref9 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(userId, isBlacklisted) {
    var res;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/set-blacklisted", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify({
                "UserId": userId,
                "IsBlacklisted": isBlacklisted
              })
            });

          case 3:
            res = _context9.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context9.next = 6;
              break;
            }

            return _context9.abrupt("return", false);

          case 6:
            return _context9.abrupt("return", true);

          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9["catch"](0);
            throw _context9.t0;

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 9]]);
  }));

  return function setIsBlacklisted(_x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();
var getDependants = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var res, dependants;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return fetchWithAuth("/api/backend/v1/users/dependent-profiles");

          case 3:
            res = _context10.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context10.next = 6;
              break;
            }

            throw {
              loginStatus: "logged out"
            };

          case 6:
            _context10.next = 8;
            return res.json();

          case 8:
            dependants = _context10.sent;
            return _context10.abrupt("return", dependants);

          case 12:
            _context10.prev = 12;
            _context10.t0 = _context10["catch"](0);
            throw _context10.t0;

          case 15:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 12]]);
  }));

  return function getDependants() {
    return _ref10.apply(this, arguments);
  };
}()));
var addDependant = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dependant) {
    var res, _yield$res$json, success;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return fetchWithAuth("/api/backend/v1/users/dependent-profiles", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify(dependant)
            });

          case 3:
            res = _context11.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context11.next = 6;
              break;
            }

            throw {
              loginStatus: "logged out"
            };

          case 6:
            _context11.next = 8;
            return res.json();

          case 8:
            _yield$res$json = _context11.sent;
            success = _yield$res$json.success;
            return _context11.abrupt("return", success);

          case 13:
            _context11.prev = 13;
            _context11.t0 = _context11["catch"](0);
            throw _context11.t0;

          case 16:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 13]]);
  }));

  return function addDependant(_x12) {
    return _ref11.apply(this, arguments);
  };
}()));
var updateDependant = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dependant) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return fetchWithAuth("/api/backend/v1/users/dependent-profiles", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify(dependant)
            });

          case 3:
            res = _context12.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context12.next = 6;
              break;
            }

            throw {
              loginStatus: "logged out"
            };

          case 6:
            return _context12.abrupt("return", true);

          case 9:
            _context12.prev = 9;
            _context12.t0 = _context12["catch"](0);
            throw _context12.t0;

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 9]]);
  }));

  return function updateDependant(_x13) {
    return _ref12.apply(this, arguments);
  };
}()));
var deleteDependant = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dependantId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return fetchWithAuth("/api/backend/v1/users/dependent-profiles?dependentProfileId=".concat(dependantId), {
              method: "DELETE"
            });

          case 3:
            res = _context13.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context13.next = 6;
              break;
            }

            throw {
              loginStatus: "logged out"
            };

          case 6:
            return _context13.abrupt("return", true);

          case 9:
            _context13.prev = 9;
            _context13.t0 = _context13["catch"](0);
            throw _context13.t0;

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 9]]);
  }));

  return function deleteDependant(_x14) {
    return _ref13.apply(this, arguments);
  };
}()));
var sendPhoneNumberVerificationCodeWithAuth = /*#__PURE__*/function () {
  var _ref14 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee14(phoneNumber) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/send-phone-number-verification-code", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify({
                phoneNumber: phoneNumber
              })
            });

          case 3:
            res = _context14.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context14.next = 13;
              break;
            }

            _context14.next = 7;
            return res.json();

          case 7:
            errorBody = _context14.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context14.next = 12;
              break;
            }

            return _context14.abrupt("return", errorBody.errors.message);

          case 12:
            return _context14.abrupt("return", ["An error occurred while processing your request."]);

          case 13:
            return _context14.abrupt("return", true);

          case 16:
            _context14.prev = 16;
            _context14.t0 = _context14["catch"](0);
            throw _context14.t0;

          case 19:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 16]]);
  }));

  return function sendPhoneNumberVerificationCodeWithAuth(_x15) {
    return _ref14.apply(this, arguments);
  };
}();
var confirmAndUpdatePhoneNumberViaCode = /*#__PURE__*/function () {
  var _ref15 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee15(phoneNumber, phoneNumberVerificationCode) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/confirm-and-update-phone-number", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "phoneNumber": phoneNumber,
                "phoneNumberVerificationCode": phoneNumberVerificationCode
              })
            });

          case 3:
            res = _context15.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context15.next = 13;
              break;
            }

            _context15.next = 7;
            return res.json();

          case 7:
            errorBody = _context15.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context15.next = 12;
              break;
            }

            return _context15.abrupt("return", errorBody.errors.message);

          case 12:
            return _context15.abrupt("return", ["The verification code is not correct or has expired."]);

          case 13:
            return _context15.abrupt("return", true);

          case 16:
            _context15.prev = 16;
            _context15.t0 = _context15["catch"](0);
            return _context15.abrupt("return", _context15.t0);

          case 19:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 16]]);
  }));

  return function confirmAndUpdatePhoneNumberViaCode(_x16, _x17) {
    return _ref15.apply(this, arguments);
  };
}();
var sendEmailVerificationCode = /*#__PURE__*/function () {
  var _ref16 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee16(email) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/send-email-verification-code", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify({
                email: email
              })
            });

          case 3:
            res = _context16.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context16.next = 13;
              break;
            }

            _context16.next = 7;
            return res.json();

          case 7:
            errorBody = _context16.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context16.next = 12;
              break;
            }

            return _context16.abrupt("return", errorBody.errors.message);

          case 12:
            return _context16.abrupt("return", ["An error occurred while processing your request."]);

          case 13:
            return _context16.abrupt("return", true);

          case 16:
            _context16.prev = 16;
            _context16.t0 = _context16["catch"](0);
            return _context16.abrupt("return", _context16.t0);

          case 19:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 16]]);
  }));

  return function sendEmailVerificationCode(_x18) {
    return _ref16.apply(this, arguments);
  };
}();
var confirmAndUpdateEmailViaCode = /*#__PURE__*/function () {
  var _ref17 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee17(email, emailVerificationCode) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/confirm-and-update-email", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "email": email,
                "emailVerificationCode": emailVerificationCode
              })
            });

          case 3:
            res = _context17.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context17.next = 13;
              break;
            }

            _context17.next = 7;
            return res.json();

          case 7:
            errorBody = _context17.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context17.next = 12;
              break;
            }

            return _context17.abrupt("return", errorBody.errors.message);

          case 12:
            return _context17.abrupt("return", ["The verification code is not correct or has expired."]);

          case 13:
            return _context17.abrupt("return", true);

          case 16:
            _context17.prev = 16;
            _context17.t0 = _context17["catch"](0);
            return _context17.abrupt("return", _context17.t0);

          case 19:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 16]]);
  }));

  return function confirmAndUpdateEmailViaCode(_x19, _x20) {
    return _ref17.apply(this, arguments);
  };
}();
var adminUpdateFirstName = /*#__PURE__*/function () {
  var _ref18 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee18(userId, firstName) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/admin-update-first-name", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "UserId": userId,
                "FirstName": firstName
              })
            });

          case 3:
            res = _context18.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context18.next = 13;
              break;
            }

            _context18.next = 7;
            return res.json();

          case 7:
            errorBody = _context18.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context18.next = 12;
              break;
            }

            return _context18.abrupt("return", errorBody.errors.message);

          case 12:
            return _context18.abrupt("return", ["Error while updating first name."]);

          case 13:
            return _context18.abrupt("return", true);

          case 16:
            _context18.prev = 16;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", _context18.t0);

          case 19:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 16]]);
  }));

  return function adminUpdateFirstName(_x21, _x22) {
    return _ref18.apply(this, arguments);
  };
}();
var adminUpdateLastName = /*#__PURE__*/function () {
  var _ref19 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee19(userId, lastName) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/admin-update-last-name", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "UserId": userId,
                "LastName": lastName
              })
            });

          case 3:
            res = _context19.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context19.next = 13;
              break;
            }

            _context19.next = 7;
            return res.json();

          case 7:
            errorBody = _context19.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context19.next = 12;
              break;
            }

            return _context19.abrupt("return", errorBody.errors.message);

          case 12:
            return _context19.abrupt("return", ["Error while updating last name."]);

          case 13:
            return _context19.abrupt("return", true);

          case 16:
            _context19.prev = 16;
            _context19.t0 = _context19["catch"](0);
            return _context19.abrupt("return", _context19.t0);

          case 19:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 16]]);
  }));

  return function adminUpdateLastName(_x23, _x24) {
    return _ref19.apply(this, arguments);
  };
}();
var adminUpdateEmail = /*#__PURE__*/function () {
  var _ref20 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee20(userId, email) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;
            _context20.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/admin-update-email", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "UserId": userId,
                "Email": email
              })
            });

          case 3:
            res = _context20.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context20.next = 13;
              break;
            }

            _context20.next = 7;
            return res.json();

          case 7:
            errorBody = _context20.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context20.next = 12;
              break;
            }

            return _context20.abrupt("return", errorBody.errors.message);

          case 12:
            return _context20.abrupt("return", ["Error while updating email."]);

          case 13:
            return _context20.abrupt("return", true);

          case 16:
            _context20.prev = 16;
            _context20.t0 = _context20["catch"](0);
            return _context20.abrupt("return", _context20.t0);

          case 19:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 16]]);
  }));

  return function adminUpdateEmail(_x25, _x26) {
    return _ref20.apply(this, arguments);
  };
}();
var adminUpdatePhoneNumber = /*#__PURE__*/function () {
  var _ref21 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee21(userId, phoneNumber) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;
            _context21.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/admin-update-phone-number", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "UserId": userId,
                "PhoneNumber": phoneNumber
              })
            });

          case 3:
            res = _context21.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context21.next = 13;
              break;
            }

            _context21.next = 7;
            return res.json();

          case 7:
            errorBody = _context21.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context21.next = 12;
              break;
            }

            return _context21.abrupt("return", errorBody.errors.message);

          case 12:
            return _context21.abrupt("return", ["Error while updating phone number."]);

          case 13:
            return _context21.abrupt("return", true);

          case 16:
            _context21.prev = 16;
            _context21.t0 = _context21["catch"](0);
            return _context21.abrupt("return", _context21.t0);

          case 19:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[0, 16]]);
  }));

  return function adminUpdatePhoneNumber(_x27, _x28) {
    return _ref21.apply(this, arguments);
  };
}();
var adminUpdateBirthDate = /*#__PURE__*/function () {
  var _ref22 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee22(userId, dateOfBirth) {
    var res, errorBody;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            _context22.next = 3;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v1/users/admin-update-birth-date", {
              headers: {
                "Content-Type": "application/json"
              },
              method: "PUT",
              body: JSON.stringify({
                "UserId": userId,
                "DateOfBirth": dateOfBirth
              })
            });

          case 3:
            res = _context22.sent;

            if (!(res.status >= 400 && res.status < 600 || res.status == 500)) {
              _context22.next = 13;
              break;
            }

            _context22.next = 7;
            return res.json();

          case 7:
            errorBody = _context22.sent;

            if (!(errorBody && errorBody.errors && errorBody.errors.message)) {
              _context22.next = 12;
              break;
            }

            return _context22.abrupt("return", errorBody.errors.message);

          case 12:
            return _context22.abrupt("return", ["Error while updating birth date."]);

          case 13:
            return _context22.abrupt("return", true);

          case 16:
            _context22.prev = 16;
            _context22.t0 = _context22["catch"](0);
            return _context22.abrupt("return", _context22.t0);

          case 19:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, null, [[0, 16]]);
  }));

  return function adminUpdateBirthDate(_x29, _x30) {
    return _ref22.apply(this, arguments);
  };
}();

/***/ })

}]);